// extracted by mini-css-extract-plugin
export default {"main":"Szukaj_main__GlIW9","icon_szukaj":"Szukaj_icon_szukaj__Wb8ZI","icon_clear":"Szukaj_icon_clear__mpklN","szukajInput":"Szukaj_szukajInput__lLMf7","icon2":"Szukaj_icon2__iq8-Z"};